import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import '@/assets/css/App.css'


function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
      />
      <AppRoutes />
    </BrowserRouter>
  )
}

export default App